import React, { useEffect, useState } from 'react';
import axiosInstance from '../utils/axiosConfig';

// v1.28.0 — "İlgilendiği projeler" seçimi (müşteri ekleme / düzenleme). Projeye tıklayınca seçilir / kaldırılır.

export interface ProjeOzet { projeID: number; projeAdi: string; }

let projeOnbellek: ProjeOzet[] | null = null;
export const projeleriGetir = async (): Promise<ProjeOzet[]> => {
    if (projeOnbellek) return projeOnbellek;
    const r = await axiosInstance.get('/api/Projeler');
    projeOnbellek = (r.data as any[]).filter(p => p.aktifMi !== false).map(p => ({ projeID: p.projeID, projeAdi: p.projeAdi }));
    return projeOnbellek;
};

const IlgiliProjeSecici: React.FC<{
    value: number[];
    onChange: (v: number[]) => void;
    disabled?: boolean;
}> = ({ value, onChange, disabled }) => {
    const [projeler, setProjeler] = useState<ProjeOzet[] | null>(projeOnbellek);
    useEffect(() => { projeleriGetir().then(setProjeler).catch(() => setProjeler([])); }, []);

    if (projeler === null) return <div style={{ fontSize: 13, color: '#94a3b8' }}><i className="fas fa-spinner fa-spin"></i></div>;
    if (projeler.length === 0) return <div style={{ fontSize: 13, color: '#94a3b8' }}>Tanımlı proje yok.</div>;
    return (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
            {projeler.map(p => {
                const secili = value.includes(p.projeID);
                return (
                    <button key={p.projeID} type="button" disabled={disabled}
                        onClick={() => onChange(secili ? value.filter(x => x !== p.projeID) : [...value, p.projeID])}
                        style={{
                            border: `1.5px solid ${secili ? '#e67e22' : '#d1d5db'}`, background: secili ? '#fff7ed' : '#fff',
                            color: secili ? '#c2410c' : '#475569', borderRadius: 8, padding: '6px 12px', fontSize: 13, fontWeight: 600,
                            cursor: disabled ? 'default' : 'pointer',
                        }}>
                        {secili && <i className="fas fa-check" style={{ marginRight: 5, fontSize: 11 }}></i>}{p.projeAdi}
                    </button>
                );
            })}
        </div>
    );
};

export default IlgiliProjeSecici;
